module.exports = __webpack_public_path__ + "static/media/redo.1b0ee64b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/images/icons/redo.svg
// module id = 754
// module chunks = 0